import React from 'react';
import EditorWrapper from "../EditorWrapper/EditorWrapper";
import Icon from "../Icon";
import svgSortAsc from "../../svgs/arrow-up.svg";
import {getData, manageData} from "../../requests/CRUD";
import {TRAINING, TRAINING_CONTENT} from "../../consts/tables";

export default class ContentPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            image: '',
            backButton: '',
            subchapterParentSlug: '',
            isEdit: false,
        };

        this.editorRef = React.createRef();
        this.contentRef = React.createRef();

        this.saveEditorContent = this.saveEditorContent.bind(this);
        this.cancelEditorChanges = this.cancelEditorChanges.bind(this);
        this.toggleEdit = this.toggleEdit.bind(this);
    }

    componentDidMount() {
        const keys = Object.keys(this.props.params);
        const slugs = this.props.params && keys.length ? keys.map(key => this.props.params[key]) : [];
        const subchapterParentSlug = slugs.join('/');
        const slug = slugs[slugs.length - 1] || '';
        const parentChapterSlug = slugs[slugs.length - 2] || '';
        slugs.pop();
        const parentSlug = slugs.join('/') || 'training';
        slugs.pop();
        const parentChapterParentSlug = slugs.join('/') || 'training';

        Promise.all([
            getData({
                tableCode: TRAINING,
                options: {
                    column: [
                        'NAME',
                        'PHOTO',
                    ],
                    filter: [{
                        text: '',
                        code: 'DELETED',
                        type: 'null',
                    }, {
                        text: parentSlug,
                        code: 'PARENT_SLUG',
                        type: 'exact',
                    }, {
                        text: slug,
                        code: 'SLUG',
                        type: 'exact',
                    }],
                    filterType: 'and',
                },
            }),
            getData({
                tableCode: TRAINING,
                options: {
                    column: [
                        'NAME',
                    ],
                    filter: [{
                        text: '',
                        code: 'DELETED',
                        type: 'null',
                    }, {
                        text: parentChapterParentSlug,
                        code: 'PARENT_SLUG',
                        type: 'exact',
                    }, {
                        text: parentChapterSlug,
                        code: 'SLUG',
                        type: 'exact',
                    }],
                    filterType: 'and',
                },
            }),
            getData({
                tableCode: TRAINING_CONTENT,
                options: {
                    column: [
                        'CONTENT',
                    ],
                    filter: [{
                        text: '',
                        code: 'DELETED',
                        type: 'null',
                    }, {
                        text: subchapterParentSlug,
                        code: 'CHAPTER_SLUG',
                        type: 'exact',
                    }],
                    filterType: 'and',
                },
            }),
        ]).then(res => {
            if (res && res[0] && res[0].success && res[1] && res[1].success && res[2] && res[2].success) {
                if (this.contentRef.current)
                    this.contentRef.current.innerHTML = res[2].data[0] ? res[2].data[0].CONTENT : '';
                this.setState({
                    title: res[0].data[0].NAME ? res[0].data[0].NAME.replace('<br/>', ' ') : '',
                    image: `${arc.path.media}training/${res[0].data[0].PHOTO}` || '',
                    backButton: res[1].data[0].NAME || '',
                    subchapterParentSlug,
                });
            }
        });
    }

    saveEditorContent() {
        if (this.editorRef.current) {
            const content = this.editorRef.current.getContent();
            manageData({
                tableCode: TRAINING_CONTENT,
                data: [{
                    CHAPTER_SLUG: this.state.subchapterParentSlug,
                    CONTENT: content
                }]
            }).then(res => {
                if (res && res.success && this.contentRef.current) {
                    this.contentRef.current.innerHTML = content;
                    this.toggleEdit();
                    return;
                }
                alert(res.message || 'Unexpected error');
            });
        }
    }

    cancelEditorChanges() {
        if (this.editorRef.current && this.contentRef.current)
            this.editorRef.current.setContent(this.contentRef.current.innerHTML);
        this.toggleEdit();
    }

    toggleEdit() {
        this.setState(prevState => {
            return {
                isEdit: !prevState.isEdit
            }
        });
    }

    render() {
        const {isSuper} = this.props;
        const {title, image, backButton, isEdit} = this.state;

        return (
            <div className='ContentPage'>
                <div className='page-rounded-corner-container'>
                    <div className='page-header-container'>
                        <div className='page-back-button'
                             onClick={() => {history.back()}}>
                            <Icon svg={svgSortAsc}/>
                            {backButton}
                        </div>
                        <div className='page-header'>
                            <div className='page-title'>{title}</div>
                            {
                                isSuper && isEdit &&
                                <React.Fragment>
                                    <div className='button-new negative' onClick={this.cancelEditorChanges}>Cancel</div>
                                    <div className='button-new positive' onClick={this.saveEditorContent}>Save</div>
                                </React.Fragment>
                            }
                            {
                                isSuper && !isEdit &&
                                <div className='button-new positive' onClick={this.toggleEdit}>Edit</div>
                            }
                        </div>
                        <div className='line'/>
                    </div>
                </div>
                <div className='page-body-container'>
                    <img src={image} className='content-image' alt=''/>
                    <div ref={this.contentRef} className={isSuper && isEdit ? 'hidden' : ''}/>
                    <EditorWrapper
                        content={this.contentRef.current && this.contentRef.current.innerHTML || ''}
                        ref={this.editorRef}
                        className={!isSuper || !isEdit ? 'hidden' : ''}
                    />
                </div>
            </div>
        )
    }
}